import './webRegSidebar.css';
import back from '../../../../images/backButton.png';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import CategorySelection from '../categorySelection/categorySelection';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import jwt from 'jwt-decode';
import { KeyboardArrowLeftRounded} from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { PROD } from '../../../../common/constants';
import { Container, Card, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import BackButton from '../../../../common/backButton';
import { useTranslation } from 'react-i18next';


const WebRegSidebar = () => {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    return (
        <>
        <Container maxWidth="xxl">
            {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG01</p>}
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} navigateTo={getLocalStorageItem('id_token') ? '../preregistration' : "/"}/>
                    <Typography variant="h5" gutterBottom>
                       {t('preReg.heading')}
                    </Typography>
                </Stack>
            <Card>
                    <CardContent>
                    <CategorySelection></CategorySelection>
                    </CardContent>
            </Card>
            </Container>
        </>
    );

}



export default WebRegSidebar;